<template>
  <a-modal
    width="600px"
    title="审核子任务"
    v-model:visible="visible"
  >
    <a-form
      class="detail-form"
      ref="form"
      :model="form"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="子任务名称">
        {{ form.name }}
      </a-form-item>
      <a-form-item label="子任务量">
        {{ total }}
      </a-form-item>
      <!--<a-form-item label="审核比例">
        <a-input-number
          v-model:value="form.percentage"
          :min="0"
          :max="1"
          :step="0.01"
          @change="form.count = parseInt(form.total * form.percentage)" />
      </a-form-item>
      <a-form-item label="审核数量">
        {{ form.count }}
      </a-form-item>-->
      <a-form-item label="选择审核员">
        <a-select
          v-model:value="form.people"
        >
          <a-select-option v-for="item in tableData" :key="item.userId">
            {{item.username}}
          </a-select-option>
         <!-- <a-select-option key="审核员1">
            审核员1
          </a-select-option>
          <a-select-option key="审核员2">
            审核员2
          </a-select-option>
          <a-select-option key="审核员3">
            审核员3
          </a-select-option>-->
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { getDataByPage } from '@/api/dataItem'
import { getUserByPage } from '@/api/user'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    addition: {
      type: String,
      default: () => ''
    },
    total: {
      type: Number,
      default: () => 0
    }
  },
  data () {
    return {
      visible: false,
      form: {
        name: '--',
        total: 20000,
        percentage: 0.1,
        count: 2000,
        people: ''
      },
      tableData: []
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.form.name = this.currentItem.name
        /*   this.form.name = this.currentItem.name
        this.form.total = this.currentItem.taskNumber ? this.currentItem.taskNumber : 20000
        this.form.count = parseInt(this.form.total * this.form.percentage) */
        this.getData()
        // this.getDataItems()
      })
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getUserByPage({ ...this.page, ...this.form }).then(async res => {
        const resData = res.data.data
        this.tableData = resData.rows
      })
    },
    getDataItems () {
      const addition = this.addition
      const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
      getDataByPage({ ...this.page, ...params }).then(res => {
        const data = res.data.map.data
        this.form.name = this.currentItem.name
        this.form.total = data.total ? data.total : 20000
        this.form.count = parseInt(this.form.total * this.form.percentage)
      })
    }
  }
}
</script>
<style lang="less">

</style>
